import { render, staticRenderFns } from "./ChangeBelong.vue?vue&type=template&id=5448e480&scoped=true&"
import script from "./ChangeBelong.vue?vue&type=script&lang=js&"
export * from "./ChangeBelong.vue?vue&type=script&lang=js&"
import style0 from "./ChangeBelong.vue?vue&type=style&index=0&id=5448e480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5448e480",
  null
  
)

export default component.exports